<template>

<div>

    <div class='col-12 alert alert-success'>
        Имате достъп до контрола върху изпълнението на този етап.
    </div>

    <auction-winner></auction-winner>

    <worker-review :pp='projectPhase'></worker-review>
    
    <br/>


</div>

</template>

<script>
    export default {

        mounted() {
            // this.getData();
        },

        created() {
           
        },

        data() {
            
            return {
                isReady : false,
                projectPhase : this.$parent.projectPhase,
                project : this.$parent.project,
                auction : false,
                delivery : false,

            }

        },

        methods : {

            // getData() {
                
            //     var me = this;

            //     me.ajax.call('phs:gaw', { pp : this.projectPhase.id }, (r) => {

            //         if( r.status == 'success' ) {

            //             me.auction = r.data.a;
            //             me.delivery = r.data.d;
            //         }

            //         me.isReady = true;
            //     })

            // },



        },

        components : {
            'auction-winner'  : require('../Owner/AuctionWinner.vue').default,
        }

    }
</script>
